import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useSalespeople(enabled = true) {
  const [list, setList] = useState([]);
  useEffect(() => {
    if (!enabled) return;
    api.get("/users/salespeople").then(({ data }) => setList(data)).catch(() => setList([]));
  }, [enabled]);
  return list;
}
